/**
 * Portal home with the plan dialog open on every plan. `?suggestPlan=true` is
 * the onboarding offer (Pro only, with the welcome discount), so a learner who
 * hits a plan wall on a test goes here instead.
 */
export const PORTAL_PLAN_PICKER_PATH = '/portal?subscribe=true';
